// Shared blog constants — single source of truth for category colors
export const CATEGORY_COLORS = {
  "AI Analytics":               "#34D399",
  "Answer Engine Insights":     "#7B93FF",
  "Answer Engine Optimization": "#4FCDC4",
  "AI Ads":                     "#A78BFA",
  "AI Automation":              "#FF9F7B",
};

export const CATEGORY_ORDER = [
  "AI Analytics",
  "Answer Engine Insights",
  "Answer Engine Optimization",
  "AI Ads",
  "AI Automation",
];
